<template>
  <div>
    <div class="container">
      <div class="profile-page-title row justify-content-center">
        <div class="col-lg-auto col-12">
          <router-link :to="{ name: 'profile.medals' }">{{ $t('my_achievements') }}</router-link>
        </div>
        <div class="col-lg-auto col-12">
          <router-link :to="{ name: 'profile.exams' }">{{ $t('tests_results') }}</router-link>
        </div>
        <div class="col-lg-auto col-12">
          <span>{{ $t('map') }}</span>
        </div>
      </div>
    </div>
    <div class="container-fluid blueback-solid  medal-text-notice" v-if="!loading">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center px-lg-0 px-5">
            <p v-if="countries === 12">{{ $t('map_congrat1') }}<br><span class="strong-green">{{ $t('map_congrat2') }}</span>
            </p>
            <p v-else>
              {{ $t('map_notice1') }}<br>
              {{ $t('map_notice2') }}<br>
              {{ $t('map_notice3') }}
              <span class="strong-green d-block mt-3">Welcome to Poliglotiki World!</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid pt-5 pb-0" v-if="countries < 12 && !loading">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center px-lg-0 px-5">
            <span class="strong-black">{{ $t('countries_opened') }}: {{ countries }} из 12</span>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row" v-if="loading">
        <div class="col-12 py-5">
        </div>
      </div>
      <div class="row justify-content-center" v-else>
        <div class="col-12">
          <img :src="mapImage()" class="my-6 px-lg-0 px-3" style="max-width: 100%;">
        </div>
        <div class="col-12 col-lg-6 pb-7 px-5">
          <h2 class="strong-green d-block mt-3">Learn more about each country</h2>
          <p>From now you are invited to the long trip to the magic world, where you will find new friends, learn, play,
            dance, sing, create, read and write, and do a lot of interesting things!</p>

          <p>Learn the traditions from each one of Poliglotiki World Countries:</p>

          <ol>
            <li><span class="strong-green">experiment</span> with science in <span class="strong-red">Eureka</span></li>
            <li><span class="strong-green">read</span> your favorite books in <span class="strong-red">Bookopoly</span>
            </li>
            <li><span class="strong-green">tell</span> the stories in <span class="strong-red">Librio</span></li>
            <li><span class="strong-green">speak</span> in <span class="strong-red">Lingvo</span></li>
            <li><span class="strong-green">dance</span> and sing in <span class="strong-red">Party Island</span></li>
            <li><span class="strong-green">make</span> discoveries in <span class="strong-red">Terra Incognita</span>
            </li>
            <li><span class="strong-green">practice</span> sport in <span class="strong-red">Olympia</span></li>
            <li><span class="strong-green">create</span> in <span class="strong-red">Museland</span></li>
            <li><span class="strong-green">write</span> letters in <span class="strong-red">Calligraphy</span></li>
            <li><span class="strong-green">make</span> shows in <span class="strong-red">Amphitheatre</span></li>
            <li><span class="strong-green">fly</span> to the stars in <span class="strong-red">Cosmopolia</span></li>
          </ol>

          <p>We&#39;ll make sure you have a great time!</p>


        </div>
      </div>


    </div>
  </div>
</template>

<script>
import progressApi from "@/data/ProgressApi";

export default {
  name: 'Browse',
  components: {},
  data() {
    return {
      loading: true,
      progress: null,
      countries: 0
    }
  },

  mounted() {
    this.fetchProgress()
  },

  methods: {
    fetchProgress() {
      this.loading = true
      progressApi.fetchProgress()
          .then(progress => {
            this.progress = progress
            this.loading = false
            console.log(progress)
          });
    },

    mapImage() {
      if (this.progress && this.progress.completedLessons && this.progress.completedLessons.length > 0) {
        console.log('completedLessons', this.progress.completedLessons.length)
        let count = 0;
        count = Math.trunc(this.progress.completedLessons.length / 5)
        if (count > 12) count = 12
        console.log('countries', this.countries)
        this.countries = count
      }
      return require(`@/assets/hometeacher/images/map/map_${this.countries}.webp`)
    }
  },

}
</script>

<style>
.profile-page-title a, .profile-page-title a:hover {
  color: #0493c3;
  border-bottom: 1px solid;
}

.medal-name {
  color: #231c37;
  font-size: 16px;
  line-height: 18px;
  font-family: "Manrope Bold";
}

.medal-image img {
  width: 100px;
  max-width: 100%;
}

.medal-none {
  opacity: 0.5;
}

.medal-category-header {
  color: #231c37;
  font-family: "Manrope Bold";
  font-size: 24px;
  margin-top: 40px;
  margin-bottom: 60px;
}

.medal-category-list-item {
  border-bottom: 1px solid #d7e1e5;
}

.medal-item {
  padding-bottom: 30px;
  cursor: pointer;
}

.medal-text-notice, .medal-text-notice p {
  font-size: 18px;
  line-height: 24px;
  color: #4f4d5c;
}

.medal-text-notice .strong-green {
  font-size: 21px;
}

.medal-text-notice.blueback-solid {
  padding-top: 35px;
  padding-bottom: 20px;
}

@media (max-width: 767px) {
  .medals-popup-absolute {
    left: 0 !important;
    top: -450px !important;
  }

}

@media (min-width: 767px) {
  .modal-dialog {
    width: 352px !important;
    max-width: 100%;
  }
}

</style>
